import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import {I18nextProvider} from "react-i18next";
import i18next from "i18next";

import home_es from "./traslations/es/home.json";
import home_en from "./traslations/en/home.json";

import navbar_es from "./traslations/es/navbar.json";
import navbar_en from "./traslations/en/navbar.json";

import contact_es from "./traslations/es/contact.json";
import contact_en from "./traslations/en/contact.json";

i18next.init({
    interpolation: {escapeValue: false},
    lng:"es",
    resources:{
        es:{
            home: home_es,
            navbar: navbar_es,
            contact: contact_es,
        },
        en:{
            home: home_en,
            navbar: navbar_en,
            contact: contact_en,
        }
    }
});

ReactDOM.render(
    <I18nextProvider i18n={i18next}>
        <App /> 
    </I18nextProvider>,
document.getElementById('root'));
